import LeavePageBlocker from './leavePageBlocker'

export default LeavePageBlocker
